import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotificationNegos } from 'src/app/models/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  readonly notificationApi = '/api/notifications/';

  constructor(private http: HttpClient) { }

  private getErrorMessage(e: any): string {
    return e?.error?.message ?? e?.message ?? (e?.status ? `HTTP ${e.status}` : 'Unknown error');
  }

  getNotification( email: string ){
    const url = this.notificationApi + email;
    return this.http.get<NotificationNegos[]>(url).pipe(
      catchError(e => {
        const message = this.getErrorMessage(e);
        console.error(message);
        return throwError(() => new Error(message));
      })
    );
  }

  putNotificationMarkRead( idProceso: number ) {
    const url = this.notificationApi + idProceso;
    return this.http.put(url, {}).pipe(
      catchError(e => {
        const message = this.getErrorMessage(e);
        return throwError(() => new Error(message));
      })
    );
  }
}